export default "__VITE_ASSET__jwlPehrM__"